/* F52 / v70 — best-seller-card colour swatches.
   Rewritten to EVENT DELEGATION on document. The previous version bound
   listeners per-swatch at DOMContentLoaded / shopify:section:load; collection
   grid cards are AJAX-injected after that (section-render rehydrate for
   collections > 50 products), so their swatches had no listeners → clicking
   did nothing. Delegation works for any card, present or future, no re-init.

   Click  = swap card image + add ?variant= to the card's product links.
   Hover  = preview that colour (desktop).
   Leave  = restore the active swatch's image. */
(function () {
  var CARD_SEL = '.lc-bs-card, article, [data-product-card]';

  function findCardImage(group) {
    var card = group.closest(CARD_SEL);
    if (!card) return { card: null, img: null };
    var img = card.querySelector('.lc-bs-card__img') || card.querySelector('img');
    return { card: card, img: img };
  }

  // Set image src AND clear srcset/sizes — a present srcset overrides a bare
  // src assignment (browser re-picks from srcset by viewport).
  function setImage(img, url) {
    if (!url || !img) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
  }

  function swatchOf(node) {
    return (node && node.closest)
      ? node.closest('.bsc__swatch:not(.bsc__swatch--more)')
      : null;
  }

  // Hover preview (desktop only — no hover on touch).
  document.addEventListener('mouseover', function (e) {
    var sw = swatchOf(e.target);
    if (!sw) return;
    var group = sw.closest('.bsc__swatches');
    if (!group) return;
    setImage(findCardImage(group).img, sw.dataset.imageUrl);
  });

  // Restore the active swatch's image when the pointer leaves the card.
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest ? e.target.closest(CARD_SEL) : null;
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return; // still inside
    var group = card.querySelector('.bsc__swatches');
    if (!group) return;
    var active = group.querySelector('.bsc__swatch[aria-pressed="true"]');
    if (active) setImage(findCardImage(group).img, active.dataset.imageUrl);
  });

  // Capture-phase mousedown — beat anchor activation before it starts.
  document.addEventListener('mousedown', function (e) {
    if (swatchOf(e.target)) { e.preventDefault(); e.stopPropagation(); }
  }, { capture: true });

  // Capture-phase click — commit the colour, block any wrapping anchor nav.
  document.addEventListener('click', function (e) {
    var sw = swatchOf(e.target);
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var group = sw.closest('.bsc__swatches');
    if (!group) return;
    var ci = findCardImage(group);

    group.querySelectorAll('.bsc__swatch').forEach(function (s) {
      s.setAttribute('aria-pressed', 'false');
    });
    sw.setAttribute('aria-pressed', 'true');

    setImage(ci.img, sw.dataset.imageUrl);

    var variantId = sw.dataset.variantId;
    if (variantId && ci.card) {
      ci.card.querySelectorAll('a[href*="/products/"]').forEach(function (l) {
        l.href = l.href.split('?')[0] + '?variant=' + variantId;
      });
    }
  }, { capture: true });
})();
